module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1056.7783eeb8.png";